import { Component, OnInit, Input } from '@angular/core';

import { Router, ActivatedRoute } from "@angular/router";
import { BACKEND_API_URL } from '../../core/services/CusHttp';

@Component({
  selector: 'app-job-company-small-infor',
  templateUrl: './job-company-small-infor.component.html',
  styleUrls: ['./job-company-small-infor.component.scss']
})
export class JobCompanySmallInforComponent implements OnInit {
  @Input() companyLogo: boolean = true;
  @Input() companyInfo;//公司信息
  public imgUrl = BACKEND_API_URL;
  constructor(
    public _router: Router,
  ) { }

  ngOnInit() {
    // console.log("aaaa",this.companyInfo);
  }

  goCompanyPage(did: any) {
    this._router.navigate(['/job/company/', did]);
  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/job/job-company-small-infor/job-company-small-infor.component.ts